import {GenericContent} from "./GenericContent";

export class Resource extends GenericContent {

    fileUrl: string;

    constructor(
        name: string,
        description: string,
        thumbnail: string,
        navUrl: string,
        fileUrl: string,
        trackingId: string,
        isPremium: boolean,
        alwaysInRoadmap: boolean
    ) {
        super(name, description, thumbnail, navUrl, trackingId, isPremium, alwaysInRoadmap);
        this.fileUrl = fileUrl;
    }
}